/**
 * The finished lesson each optimistic action draws at once (speed.md 2,
 * decision 157), as the server's answer would draw it: pure, so tested.
 */
import { whenLine } from './liveCalendar.ts';
import type { BookingPatch } from '../services/optimistic.ts';

interface Timed {
  scheduledStartAt: string;
  windowOpenAt?: string;
  windowCloseAt?: string;
  durationMinutes?: number;
}

const shift = (iso: string | undefined, by: number) => (iso ? new Date(Date.parse(iso) + by).toISOString() : iso);

/** Set New Time or an accepted proposal: the lesson at its new start, its call window moved with it, "Moved to ...". */
export function movedPatch(b: Timed, startAt: string, tz: string): BookingPatch {
  const by = Date.parse(startAt) - Date.parse(b.scheduledStartAt);
  const patch: BookingPatch = { scheduledStartAt: new Date(startAt).toISOString(), movedTo: `Moved to ${whenLine(startAt, tz)}` };
  if (b.windowOpenAt) patch.windowOpenAt = shift(b.windowOpenAt, by);
  if (b.windowCloseAt) patch.windowCloseAt = shift(b.windowCloseAt, by);
  return patch;
}

/** The coach's decision on a player no-show (154; contracts 13): the decided line, Count and Offer gone. */
export function noShowPatch(
  b: { missResolution?: { status: string; reason?: string; dueAt?: string; decidedBy?: string } | null },
  choice: 'count' | 'offer',
): BookingPatch {
  return {
    missResolution: { ...(b.missResolution ?? { reason: 'player_no_show' }), status: choice === 'count' ? 'counted' : 'offered', decidedBy: 'coach' },
  } as BookingPatch;
}
